//本地代理 发布环境['-test','-uat','']
let ENV = '';

let NowApiDianDian=''
let NowApiCms=''

switch (ENV) {
    case '-test':
        if(process.env.NODE_ENV=='development'){
            //dev
            NowApiDianDian='http://localhost:8084/diandian'
            NowApiCms='http://localhost:8084/ddcms'
        }else{
            //test
            NowApiDianDian='https://diandian-test2.zhongan.com/noah/apiAction.do'
            NowApiCms='https://dd-cms-test.zhongan.com/apiAction.do'
        }
        break;
    case '-uat':
        //NowApiDianDian='https://diandian' + ENV + '.zhongan.com/apiAction.do'
        NowApiDianDian='https://diandian-mics-uat.zhongan.com/apiAction.do'
        NowApiCms='https://cms-uat.zhongan.com/apiAction.do'
        break;
    case '':
        //NowApiDianDian='https://diandian' + ENV + '.zhongan.com/apiAction.do'
        NowApiDianDian='https://finance.diandian.com.cn/apiAction.do'
        NowApiCms='https://cms.diandian.com.cn/apiAction.do'
        break;
}

module.exports = {
    ENV: ENV,
    API_ROOT: NowApiDianDian,
    API_CMS: NowApiCms
}

// module.exports = {
//     ENV: ENV,
//     API_ROOT: process.env.NODE_ENV !== 'production'
//         ? 'http://localhost:8084/diandian'
//         : 'https://diandian' + ENV + '.zhongan.com/apiAction.do',
//     API_CMS: process.env.NODE_ENV !== 'production'
//         ? 'http://localhost:8084/ddcms'
//         : 'https://cms'+ENV+'.zhongan.com/apiAction.do'
// }



// WEBPACK FOOTER //
// ./src/config.js